import { gql } from "@apollo/client";

export const STREAM_ALGO = gql`
  mutation streamAlgo($id: Int!, $algo: Boolean!) {
    streamAlgo(id: $id, algo: $algo) {
      id
      message
      isError
    }
  }
`;
